/* AUREL — scripts propios (prefijo au-). Vanilla JS, sin librerías. */
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initStickyBuy();
});

function initReveal() {
  var items = document.querySelectorAll('.au-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('au-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('au-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  items.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-au-galeria]');
  if (!galeria) return;

  var main = galeria.querySelector('[data-au-galeria-principal]');
  var thumbs = galeria.querySelectorAll('[data-au-galeria-thumb]');
  if (!main || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-au-galeria-thumb');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!url) return;
      main.style.opacity = '0';
      window.setTimeout(function () {
        main.setAttribute('src', url);
        main.setAttribute('alt', alt);
        main.style.opacity = '1';
      }, 120);
      thumbs.forEach(function (t) { t.classList.remove('au-thumb-activa'); });
      thumb.classList.add('au-thumb-activa');

      var color = thumb.getAttribute('data-au-color');
      if (color) {
        var select = document.querySelector('.au-opcion-select');
        if (select && select.value !== color) {
          select.value = color;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
}

function formatearDinero(centavos) {
  var valor = (centavos / 100).toFixed(2).replace('.', ',');
  return valor + ' €';
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('.au-producto-form');
  forms.forEach(function (form) {
    var datosEl = form.querySelector('[data-au-variantes]');
    var selects = form.querySelectorAll('.au-opcion-select');
    if (!datosEl || !selects.length) return;

    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = form.querySelector('input[name="id"]');
    var boton = form.querySelector('.au-producto-boton');
    var wrapper = form.closest('.au-producto-compra') || document;
    var precioActual = wrapper.querySelector('.au-precio-actual');
    var precioTachado = wrapper.querySelector('.au-precio-tachado');
    var imagenPrincipal = document.querySelector('[data-au-galeria-principal]');

    function seleccionActual() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      return valores;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantes.filter(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      })[0];
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (inputId) inputId.value = variante.id;

      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioTachado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachado.textContent = formatearDinero(variante.compare_at_price);
          precioTachado.hidden = false;
        } else {
          precioTachado.hidden = true;
        }
      }

      if (boton) {
        if (variante.available) {
          boton.disabled = false;
          boton.textContent = boton.getAttribute('data-texto-disponible') || boton.textContent;
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-agotado') || boton.textContent;
        }
      }

      if (imagenPrincipal && variante.featured_image && variante.featured_image.src) {
        imagenPrincipal.style.opacity = '0';
        window.setTimeout(function () {
          imagenPrincipal.setAttribute('src', variante.featured_image.src);
          imagenPrincipal.setAttribute('alt', variante.featured_image.alt || imagenPrincipal.getAttribute('alt'));
          imagenPrincipal.style.opacity = '1';
        }, 120);
      }

      var miniaturas = document.querySelectorAll('[data-au-galeria-thumb]');
      miniaturas.forEach(function (t) {
        var esDeEsteColor = t.getAttribute('data-au-color') === variante.title;
        t.classList.toggle('au-thumb-activa', esDeEsteColor);
      });

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url);
      }

      var stickyPrecio = document.querySelector('[data-au-sticky-precio]');
      var stickyBoton = document.querySelector('[data-au-sticky-boton]');
      var stickyImagen = document.querySelector('[data-au-sticky-imagen]');
      if (stickyPrecio) stickyPrecio.textContent = formatearDinero(variante.price);
      if (stickyImagen && variante.featured_image && variante.featured_image.src) {
        stickyImagen.setAttribute('src', variante.featured_image.src);
        stickyImagen.setAttribute('alt', variante.featured_image.alt || stickyImagen.getAttribute('alt'));
      }
      if (stickyBoton) {
        if (variante.available) {
          stickyBoton.disabled = false;
          stickyBoton.textContent = stickyBoton.getAttribute('data-texto-disponible') || stickyBoton.textContent;
        } else {
          stickyBoton.disabled = true;
          stickyBoton.textContent = stickyBoton.getAttribute('data-texto-agotado') || stickyBoton.textContent;
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', actualizar);
    });
  });
}

function initStickyBuy() {
  var barra = document.querySelector('[data-au-sticky-buy]');
  var botonPrincipal = document.querySelector('.au-producto-boton');
  var botonSticky = document.querySelector('[data-au-sticky-boton]');
  if (!barra || !botonPrincipal || !botonSticky) return;

  botonSticky.addEventListener('click', function () {
    botonPrincipal.click();
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          barra.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(botonPrincipal);
  }
}
